<template>
  <el-table :data="traceData" size="mini" height="220" border>
    <el-table-column prop="parentType" :label="columnLabel[cardType]" header-align="center" />
    <el-table-column prop="dataSum" :label="unitType" header-align="center">
      <template slot-scope="scope">
        {{ convertDataSum(scope.row.dataSum) }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WSmartTraceTable',
  props: {
    traceData: Array,
    cardType: String,
    unitType: String,
  },
  data() {
    return {
      columnLabel: {
        ipaddress: '호스트명',
        protocol: '프로토콜명',
        conversation: 'Conversation',
        port: '서비스명',
        netinterface: '인터페이스명',
      },
    };
  },
  methods: {
    convertDataSum(data) {
      return convertValuByUnit(data, null, true, false);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/components/table/SmartTraceTable.vue